export default __webpack_public_path__ + "887c54a5b088fd14fb4673233269abb7.png";